import { tw } from '@/utils/tw';
import { DialogTheme } from '@/components/Dialog/theme';

const PaymentCompletedDialogTheme = tw.theme({
  slots: {
    base: [],
  },
});

export default Object.assign(PaymentCompletedDialogTheme, {
  Dialog: DialogTheme,
});
